export interface WordToLinkResult {
  isLink: boolean

  /**
   * The link that was found
   */
  link: string

  /**
   * The href that should be used for the link
   */
  href: string

  /**
   * For any punctuation that comes after the link
   */
  afterLink: string
}

export const wordToLink = (word: string) => {
  const rules = [/https?:\/\/[^\s]+/g, /www\.[^\s]+/g, /([^\s]+\.[a-zA-Z]+)/g]
  const punctuationRegex = /([^\w\s\/-]+$)/
  const isLink = rules.some((rule) => rule.test(word))

  if (!isLink) {
    return {
      isLink: false,
      link: '',
      href: '',
      afterLink: '',
    }
  }

  const endMatch = punctuationRegex.exec(word)
  const sanitizedWord = word.replace(punctuationRegex, '')
  const href = sanitizedWord.startsWith('http') ? sanitizedWord : `https://${sanitizedWord}`

  return {
    isLink: true,
    href,
    link: sanitizedWord,
    afterLink: endMatch ? endMatch[0] : '',
  }
}
